module.exports = __webpack_public_path__ + "img/a44fe27.jpg";